// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__pGzjy","home_title":"preset_apps_home_title__-DDk7","foot":"preset_apps_foot__oQdPJ"};